/**
 * pageCache — session-lived stale-while-revalidate store for page data.
 *
 * Tab switches should never show a loading screen for data we've already
 * fetched: pages seed their state from here (data on first paint), then
 * re-fetch in the background and update in place. The cache lives for the
 * SPA session only — a hard refresh starts clean.
 */
const store = new Map<string, any>();

export const pageCache = {
  get<T = any>(key: string): T | undefined {
    return store.get(key);
  },
  has(key: string): boolean {
    return store.has(key);
  },
  set(key: string, value: any): void {
    store.set(key, value);
  },
  /** Invalidate everything under a prefix after a data mutation (upload,
   *  invoice confirm, settings change). Empty prefix clears all. */
  clear(prefix = ''): void {
    Array.from(store.keys()).forEach((k) => {
      if (k.startsWith(prefix)) store.delete(k);
    });
  },
};
